import { render, staticRenderFns } from "./result.vue?vue&type=template&id=4398db4d&scoped=true"
import script from "./result.vue?vue&type=script&lang=ts&setup=true"
export * from "./result.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./result.vue?vue&type=style&index=0&id=4398db4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4398db4d",
  null
  
)

export default component.exports